﻿import { AdminMetricCard } from "@/components/admin";
import type { AdminStatusTone } from "@/lib/adminCodeDisplay";

interface SoundSummaryCardsProps {
  soundType: string;
  detailCategory: string;
  confidenceLabel: string;
  statusLabel: string;
  analysisSource: string;
}

interface SoundDetailSummaryCard {
  title: string;
  value: string;
  badge: string;
  description: string;
  tone: AdminStatusTone;
  icon: string;
}

const SoundSummaryCards = ({ soundType, detailCategory, confidenceLabel, statusLabel, analysisSource }: SoundSummaryCardsProps) => {
  const cards: SoundDetailSummaryCard[] = [
    { title: "소리 유형", value: soundType, badge: statusLabel, description: "API 판정값", tone: "blue", icon: "ri-sound-module-line" },
    { title: "세부 분류", value: detailCategory, badge: "분류", description: "API 분류값", tone: "violet", icon: "ri-price-tag-3-line" },
    { title: "신뢰도", value: confidenceLabel, badge: "참고", description: "분석 참고값", tone: "amber", icon: "ri-bar-chart-box-line" },
    { title: "분석 출처", value: analysisSource, badge: "수집", description: "수집 기준", tone: "slate", icon: "ri-database-2-line" },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map((card) => (
        <AdminMetricCard
          key={card.title}
          title={card.title}
          value={card.value}
          badge={card.badge}
          description={card.description}
          tone={card.tone}
          icon={card.icon}
          variant="filled"
        />
      ))}
    </div>
  );
};

export default SoundSummaryCards;
